import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import './style.scss';

const UnitReasons = ({reasons}) => (
    <div className="unit__reasons">
        {_.map(reasons, (reason, index) => (
            <div className={`unit__reasons--${reason.type.toLowerCase()}`}
                 key={index}>
                <span className="unit__reasons__subj"><FormattedMessage
                    id={`unit.reasons.subject.${reason.subject.toLowerCase().trim()}`}/> </span>
                {reason.message}
            </div>
        ))}
    </div>
);

UnitReasons.propTypes = {
    reasons: PropTypes.array
};

export default UnitReasons;